<template>
  <div v-if="listData?.length > 0" style="padding-bottom:0;" class="full-width">
    <div class="golf-good-price mb-10">
      <p class="c-black-text c-bold-text title-h3 m-0">
        {{ title }}
      </p>

      <div class="d-flex align-items-center">
        <CountDownTime
          v-if="isFlashSale == 1"
          :nameCountDown="name_count_down"
          :timeEndCountDown="endDateSale"
          :timeStartCountDown="startDateSale"
        />
        <p @click="pushRouter" class="m-0 ml-10 text-see-more cursor-pointer">
          {{ $t("viewAll") }}
        </p>
      </div>
    </div>
    <el-row :gutter="20">
      <vue-slick-carousel v-if="listData?.length > 0" v-bind="slickOptions">
        <div v-for="(item, index) in listData" :key="index">
          <card-facility
            :object-data="item"
            :price="item.price"
            :price-discount="item.price_sale"
            :start-time="formattedTime(item.time_start)"
            :end-time="formattedTime(item.time_end)"
            :start-date="item.date_start"
            :end-date="item.date_end"
            :title="item?.facility_name"
            :image="item?.images"
            :facility-id="item.facility_id"
            :id="item?.id"
          />
        </div>
      </vue-slick-carousel>
    </el-row>
  </div>
</template>
<script>
import CardFacility from "@/components/wapV2/cards/CardFacility.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import CountDownTime from "@/views/components/wapV2/CountDownTime";

export default {
  name: "carousel-facility",
  components: {
    CardFacility,
    VueSlickCarousel,
    CountDownTime
  },
  props: {
    listData: {
      type: Array,
      return: []
    },
    title: {
      type: String,
      default: ""
    },
    isFlashSale: {
      type: Number,
      default: 1
    },
    startDateSale: {
      type: Number,
      default: 0
    },
    endDateSale: {
      type: Number,
      default: 0
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},

  data() {
    return {
      name_count_down: "time1",
      slickOptions: {
        dots: false,
        arrows: false,
        autoplaySpeed: 2000,
        autoplay: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true
            }
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true
            }
          },

          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              variableWidth: true
            }
          }
        ]
      }
    };
  },
  methods: {
    pushRouter() {
      const data = this.listData;
      const flash_sale_id = data[0].flash_sale_id;
      const params = {
        title: this.title,
        flash_sale_id,
        is_flash_sale: this.isFlashSale,
        start_date_sale: this.startDateSale,
        end_date_sale: this.endDateSale
      };
      const query = new URLSearchParams(params).toString();
      return this.$router.push(`/teetime?${query}`);
    },
    formattedTime(time) {
      const [hh, mm] = time.split(":");
      const formattedTime = `${hh}:${mm}`;
      return formattedTime;
    }
  }
};
</script>

<style>
.slick-slide {
  padding-right: 10px;
  padding-left: 10px;
}
</style>

<style scoped lang="scss">
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
}
.text-see-more {
  color: #858585;
  font-size: 12px;
}
.title-h3 {
  font-size: 16px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .title-h3 {
    font-size: 14px;
  }
  .text-see-more {
    font-size: 10px;
  }
}
</style>
